import { useSelector } from 'react-redux'

export default function usePriceManagementStoragePrefix(type) {
  const { userDetails } = useSelector(({ auth }) => auth)
  const customerId = userDetails && userDetails.customerId
  const username = userDetails && userDetails.username

  return `UCC_priceManagementAccepted_${customerId}_${username}_${type}`
}
